import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Plus, Image } from "lucide-react";
import { useGlobal } from "../../context/GlobalContext";
import { images } from "../../assets/images";
import storage from "../../assets/js/Global";

const ChatList = () => {
  const { chatList, getChatList } = useGlobal();
  const [search, setSearch] = useState("");
  const currentUser = storage.get("user");

  useEffect(() => {
    getChatList(search);
  }, [getChatList, search]);

  const navigate = useNavigate();

  return (
    <div className="web-chat-container">
      <div className="chat-sidebar">
        <div className="sidebar-header">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">Messages</h4>
            <button
              className="web-send-btn shadow-sm"
              style={{ width: 36, height: 36, borderRadius: 10 }}
              onClick={() => navigate("/new-chat-list")}
            >
              <Plus size={20} />
            </button>
          </div>
          <div className="form-group position-relative">
            <Search
              className="position-absolute text-muted"
              size={18}
              style={{
                left: "14px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
            <input
              type="text"
              className="form-control border-0 bg-light rounded-pill fs-15 input-tags"
              style={{ paddingLeft: "42px", height: "48px" }}
              placeholder="Search conversations..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="chat-list-scroll">
          {chatList.length > 0 ? (
            chatList?.map((item) => {
              const emp = item.employee || {};
              const name = `${emp.name || ""}`.trim() || "Unknown";
              const avatar = emp.profile_img || images.userAvatar;
              const message = item.message;
              const time = item.date_time;
              const unread =
                item?.last_message_sender_id !== currentUser?.user_pid &&
                item.status === "unread";

              return (
                <div
                  key={item.room_pid}
                  className="web-chat-item"
                  onClick={() => {
                    storage.set("selectedRoom", item);
                    storage.set("selectedUser", item.employee);

                    navigate("/chats", {
                      state: {
                        room: item,
                      },
                    });
                  }}
                >
                  <div className="position-relative">
                    <img
                      src={avatar}
                      alt={name}
                      className="chat-avatar-lg"
                      onError={(e) => {
                        e.currentTarget.src = images.userAvatar;
                      }}
                    />
                  </div>

                  <div className="chat-info-block">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="chat-user-name">{name}</span>
                      <span className="chat-time-stamp">{time}</span>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                      <span className="chat-preview-text  align-items-center text-primary gap-1">
                        {message === "photo" ? (
                          <div className="d-flex align-items-center gap-1">
                            <Image size={13} />
                            <span>Photo</span>
                          </div>
                        ) : (
                          message || "No messages yet"
                        )}
                      </span>

                      {unread && (
                        <span className="msg-count-badge ms-2">
                          {item?.unread_count}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : search.trim() ? (
            <p className="text-muted text-center mt-4">
              No conversations found for "<strong>{search}</strong>"
            </p>
          ) : (
            <p className="text-muted text-center mt-4 px-3 fs-15">
              Your inbox is empty. Start a new chat and connect!
            </p>
          )}
        </div>
      </div>

      <div className="chat-main-area d-none d-md-flex align-items-center justify-content-center bg-light bg-opacity-50">
        <div className="text-center p-5 animate-bounce-in">
          <div className="bg-white p-4 rounded-circle shadow-sm d-inline-block mb-4">
            <i className="fa-regular fa-comments text-primary fs-1"></i>
          </div>
          <h4 className="fw-semibold text-dark mb-2">Your Conversations</h4>
          <p className="text-muted fs-15 mb-4">
            Select a chat from the sidebar to start
            <br />
            messaging with your team or clients.
          </p>
          <button
            className="btn btn-secondary px-4 py-2"
            onClick={() => navigate("/new-chat-list")}
          >
            Start New Chat
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatList;
